import { render, staticRenderFns } from "./unit_fields.vue?vue&type=template&id=669f2b49&scoped=true"
import script from "./unit_fields.vue?vue&type=script&lang=js"
export * from "./unit_fields.vue?vue&type=script&lang=js"
import style0 from "./unit_fields.vue?vue&type=style&index=0&id=669f2b49&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f2b49",
  null
  
)

export default component.exports